export const UPDATE_KNOWLEDGE = "UPDATE_KNOWLEDGE";
export const GET_MY_KNOWLEDGE = "GET_MY_KNOWLEDGE";
export const GET_MY_SHARED_KNOWLEDGE = "GET_MY_SHARED_KNOWLEDGE";
export const UPDATE_KNOWLEDGE_VIEW = "UPDATE_KNOWLEDGE_VIEW";
export const IS_LOADING_KNOWLEDGE = "IS_LOADING_KNOWLEDGE";
export const IS_LOADING_SHARED = "IS_LOADING_SHARED";
export const CREATE_QA = "CREATE_QA"
export const CREATE_ARTICLE = "CREATE_ARTICLE"

export const CHANGE_VIEW_MODE = "CHANGE_VIEW_MODE"

export const GET_SUGGESTED_TAGS = "GET_SUGGESTED_TAGS"
export const IS_LOADING = "IS_LOADING";

export const VIEW_KNOWLEDGE = "VIEW_KNOWLEDGE"
export const IS_LOADING_VIEW = "IS_LOADING_VIEW"
export const DELETE_KNOWLEDGE = "DELETE_KNOWLEDGE"
export const SHARE_KNOWLEDGE = "SHARE_KNOWLEDGE"
export const PAGE_INFO_NOTES = "PAGE_INFO_NOTES";